import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Quiz } from "@/components/landing/Quiz";
import { ProductShowcase } from "@/components/landing/ProductShowcase";
import { Features } from "@/components/landing/Features";
import { Comparison } from "@/components/landing/Comparison";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Testimonials } from "@/components/landing/Testimonials";
import { Pricing } from "@/components/landing/Pricing";
import { Socials } from "@/components/landing/Socials";
import { CTA } from "@/components/landing/CTA";
import { Footer } from "@/components/landing/Footer";
import { VideoModal } from "@/components/landing/VideoModal";
import { Welcome } from "@/components/landing/Welcome";
import { Admin } from "@/components/landing/Admin";
import { Checklist } from "@/components/landing/Checklist";
import { Privacy } from "@/components/landing/Privacy";
import { Terms } from "@/components/landing/Terms";

const Landing = () => (
  <div className="App">
    <div className="noise-overlay" />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <Quiz />
      <ProductShowcase />
      <Features />
      <Comparison />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <Socials />
      <CTA />
    </main>
    <Footer />
    <VideoModal />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/checklist" element={<Checklist />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
